export enum IssueSeverityEnum {
  VERY_LOW = 'Very low',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  VERY_HIGH = 'Very high',
  CRITICAL = 'Critical',
}

export type IssueSeverityType =
  | 'Very low'
  | 'Low'
  | 'Medium'
  | 'High'
  | 'Very high'
  | 'Critical';
export type IssueSeverityTypeWithNull = IssueSeverityType | 'null';
